<template>
    <website-page centered>
        <e-container class="mb-4" :max-width="800">
            <div v-show="mainTab === TABS.HOME">

                <h2 class="mb-1 text-uppercase" style="letter-spacing: 1px" v-tr>Welcome to|Bienvenue chez</h2>
                <h1 class="mb-4 mt-0" style="font-size: 50pt" v-tr>MyClinic|MaClinique</h1>
                <h3 class="mb-3" v-tr>How can we help you today?|Comment pouvons-nous vous aider aujourd'hui ?</h3>

                <b-row>
                    <b-col cols="12" md="6">
                        <b-card @click="setTab(TABS.CHECK_IN)" img-src="https://eyeinlivestorage.blob.core.windows.net/public/clients/demo-hospital/checkin-carte-ramq.jpg">
                            <b-btn variant="accent" class="py-2" block>
                                <h3 class="m-0" v-tr>Check-in|M'enregistrer</h3>
                            </b-btn>
                            <h5 class="mt-3 mb-0" v-tr>You will need your Card|Avec votre carte RAMQ</h5>
                        </b-card>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-card img-src="https://eyeindevstorage.blob.core.windows.net/eye-intelligence/cms/medias/hopitallakeshore/department-admission.jpg">
                            <b-btn variant="accent" class="py-2" block>
                                <h3 class="m-0" v-tr>Book appointment|Planifier un RDV</h3>
                            </b-btn>
                            <h5 class="mt-3 mb-0" v-tr>Schedule your next visit|Planifiez votre prochain RDV</h5>
                        </b-card>
                    </b-col>
                </b-row>


                <b-card class="mt-5">
                    <h3 class="mt-1 mb-3" v-tr>Need Help?|Besoin d'aide ?</h3>
                    <b-btn variant="primary" class="py-2">
                        <h4 class="m-0">
                            <i class="fas fa-phone mr-2"/>
                            <span v-tr>Contact Reception|Contacter la réception</span>
                        </h4>
                    </b-btn>
                </b-card>
            </div>

            <div v-show="mainTab === TABS.CHECK_IN">
                <b-card class="mt-5">

                    <h2 v-tr>Please scan your RAMQ Card|Merci de scanner votre carte de RAMQ</h2>
                    <e-input :minlength="9" required maxlength="9" v-model="idCard" class="mx-auto my-3 text-center" :placeholder="tr(`Your ID|Num. Assur. Malad.`)" autofocus style="box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2); padding: 20px 20px; font-size: 18pt; width: 300px; text-transform: uppercase"/>

                    <b-img class="mt-3" width="500" src="https://eyeinlivestorage.blob.core.windows.net/public/clients/demo-hospital/2-cartes-ramq.png" style="box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25); border-radius: 12px; max-width: 100%"/>

                    <template #footer>
                        <div class="w-100 text-right">
                            <b-btn class="float-left" variant="light" @click="setTab(TABS.HOME)" size="lg">
                                <i class="fas fa-chevron-left mr-1"/>
                                <span v-tr>Back|Retour</span>
                            </b-btn>
                            <b-btn variant="accent" @click="setTab(TABS.CHECKED_IN)" size="lg">
                                <span v-tr>Check-In|M'enregistrer</span>
                                <i class="fas fa-chevron-right ml-1"/>
                            </b-btn>
                        </div>
                    </template>
                </b-card>

                <b-card class="mt-4 text-left">
                    <template #header>
                        <h4 class="my-0">
                            <i class="fas fa-info-circle mr-2"/>
                            <span v-tr>Help|Aide</span>
                        </h4>
                    </template>
                    <h4 v-tr>How can I scan my card?|Comment numériser ma carte?</h4>
                    <p v-tr>Find the barcode on the back of your card if you have the new model. Place the card below the arrow that indicates Scan here|Vous pouvez trouver le code bar au dos de votre carte RAMQ si vous avze le nouveau modèle. Placez la carte en dessous de la flèche qui indique de scanner ici</p>
                    <b-img class="mt-2" width="500" src="https://eyeinlivestorage.blob.core.windows.net/public/clients/demo-hospital/kiosk-close-up-scan-barcode.jpg" style="box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25); border-radius: 12px; max-width: 100%"/>
                    <hr>
                    <h4 v-tr>I don't have my card with me, what can I do?|Je n'ai pas ma carte avec moi ?</h4>
                    <p v-tr>You will need to pay in advance, and provide personal information manually|Vous devrez payer en avance, et fournir vos informations personnelles manuellement</p>
                    <hr>
                    <h4 v-tr>Need more help?|Besoin d'aide?</h4>
                    <p v-tr>Please contact the reception|Merci de contacter la réception</p>
                    <b-btn class="mt-3" variant="accent" to="/map/?end=4EA5026F-F1E7-4580-9FB5-3CEABFEB914A">
                        <i class="fas fa-phone mr-2"/>
                        <span v-tr>Contact Reception|Contacter la réception</span>
                    </b-btn>
                </b-card>
            </div>

            <div v-show="mainTab === TABS.CHECKED_IN">
                <b-card>
                    <h3 v-tr>Thank you for checking in!|Merci de vous être enregistré</h3>
                    <b-img src="https://eyeinlivestorage.blob.core.windows.net/public/clients/demo-hospital/check.png" width="200"/>
                    <h1 v-tr class="mx-auto" style="background-color: #e5f4d9; border: 2px solid #15b703; border-radius: 12px; padding: 8px 16px; margin-top: -20px; width: 300px; z-index: 1; position: relative;">Number 38|Numéro 38</h1>
                    <p v-tr>Please take a seat, we will call your number when it's your turn!|Merci de prendre une chaise et de patienter, nous vous appellerons quand ce sera votre tour</p>

                    <b-img class="mt-3" width="500" src="https://eyeinlivestorage.blob.core.windows.net/public/clients/demo-hospital/go-to-waiting-room.jpg" style="box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25); border-radius: 12px; max-width: 100%"/>

<!--                    <template #footer>-->
<!--                        <div class="w-100 text-right">-->
<!--                            <b-btn class="float-left" variant="light" @click="setTab(TABS.HOME)" size="lg">-->
<!--                                <i class="fas fa-chevron-left mr-1"/>-->
<!--                                <span v-tr>Back|Retour</span>-->
<!--                            </b-btn>-->
<!--                            <b-btn variant="accent" @click="checkIn()" size="lg">-->
<!--                                <span v-tr>Check-In|M'enregistrer</span>-->
<!--                                <i class="fas fa-chevron-right ml-1"/>-->
<!--                            </b-btn>-->
<!--                        </div>-->
<!--                    </template>-->
                </b-card>
            </div>
        </e-container>
    </website-page>
</template>

<script>
import EInput from "../../vue-components/components/e-input.vue";
import VirtualKeyboard from "../components/virtual-keyboard.vue";
import EContainer from "@vue-components/components/e-container.vue";

export default {
    name: `check-in`,
    components: {EContainer, EInput, VirtualKeyboard},
    data() {
        return {
            TABS: {
                HOME: `home`,
                CHECK_IN: `check-in`,
                CHECKED_IN: `checked-in`,
                CREATE_CARD: `create-card`
            },
            mainTab: `home`,
            idCard: ``
        }
    },
    activated() {
        this.mainTab = this.TABS.CHECK_IN;
        this.idCard = ``;
    },
    methods: {
        setTab(tab) {
            this.mainTab = tab;
        },
        checkIn() {
            this.showSavedMessage(`Checked-In|Enregistré`, `You have been checked-in successfully.|Vous avez été enregistré avec succès.`);
            this.idCard = ``;
            this.setTab(this.TABS.HOME);
        },
        onKeyboardChange(input) {
            this.idCard = input;
            if (this.idCard.length >= 9) {
                this.idCard = this.idCard.substring(0, 9);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.cms-website {
    background: url("https://eyeinlivestorage.blob.core.windows.net/public/clients/demo-hospital/abstract-bg.jpg");
    --card-border-radius: 12px;

    .card {
        border-radius: var(--card-border-radius);
        box-shadow: 0 5px 25px rgba(black, 0.15);
    }
}
</style>
